export const useIsLatam = (country: string) =>
	['peru', 'ecuador', 'mexico', 'colombia'].includes(country);
